import type { ReactNode } from 'react';
import type { FlagDefinition } from './flag';
import { useFlagEnabled } from './use-flag-enabled.hook';

type FlagBypassProps = {
  flag: FlagDefinition;
  guards: (content: ReactNode) => ReactNode;
  children: ReactNode;
};

/**
 * Renders children directly when the per-user flag is enabled (bypassing guards).
 * When disabled, wraps children through the guards render function,
 * which applies standard access controls (e.g. ConfigGuard, ProtectedRoute).
 */
export function FlagBypass({ flag, guards, children }: FlagBypassProps) {
  const enabled = useFlagEnabled(flag);
  return <>{enabled ? children : guards(children)}</>;
}
